import {
    apiGoldTraderPresent,
    apiGoldTraderHistory,
    apiGoldHistoryGraph,
    apiGoldSpotLastQuote,
    apiGoldSpotRealtimeConversion,
    apiGoldSpotPreviousClose,
    apiGoldSpotHistoryGraph,
    apiGoldSpotSnapshot,
} from '../../api/gold.js'

import {
    apiFetchGcsObject
} from '../../api/global.js'

import * as constant from './constant'

export const actions = {
    async findGoldTraderPresent({ commit }) {
        const rs = await apiGoldTraderPresent();
        if (rs && rs.status == 200) {
            let data = rs.data.data
            if (data && typeof (data) !== 'string') {
                await commit(constant.GOLD_TRADER_PRESENT, { data })
                return data
            }
        }
    },
    async findGoldTraderHistory({ commit }, date) {
        const rs = await apiGoldTraderHistory(date);
        if (rs && rs.status == 200) {
            let data = rs.data.data
            if (data) await commit(constant.GOLD_HISTORY_LIST, { date, data })
        }
    },
    async findGoldHistoryGraph({ commit }, period) {
        try {
            const rs = await apiGoldHistoryGraph(period);
            if (rs && rs.status == 200) {
                let data = rs.data.data
                if (data) {
                    if (period == "1D") await commit(constant.GOLD_TRADER_HISTORY_GRAPH, data)
                    else await commit(constant.GOLD_TRADER_HISTORY_GRAPH, data)
                    return data
                }
            }
        } catch (error) {
            throw new Error(error)
        }
    },
    async clearGoldHistory({ state }) {
        state.goldHistoryList = []
    },
    async findGoldSpotLastQuote({ commit }, payload) {
        const rs = await apiGoldSpotLastQuote(payload);
        if (rs && rs.status == 200) {
            let data = rs.data.last
            if (data) {
                await commit(constant.GOLD_SPOT_LAST_QUOTE, data)
            }
        }
    },
    async findGoldSpotRealtime({ commit }) {
        let obj = {
            from: "XAU",
            to: "USD"
        }
        const rs = await apiGoldSpotRealtimeConversion(obj);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                await commit(constant.GOLD_SPOT_REAL_TIME, data)
            }
        }
    },
    async fetchGoldSpotAggregate({ commit }, payload) {
        try {
            const rs = await apiGoldSpotHistoryGraph(payload)
            if (rs && rs.status == 200) {
                let data = rs.data.results
                if (data) return data
                return []
            }
        } catch (error) {
            throw new Error(error)
        }
    },
    async fetchGoldSpotSnapshot({ commit }, {period, marketStatus, snapshotKey, startTimeframe}) {
        try {
            const rs = await apiGoldSpotSnapshot({period, marketStatus, snapshotKey, startTimeframe})
            if (rs && rs.status == 200) {
                let data = rs.data
                if (data) return data
                return []
            }
        } catch (error) {
            throw new Error(error)
        }
    },
    async fetchGoldTraderHistoryGraph({ commit }, {period, sampling, startTimeframe}) {
        try {
            const rs = await apiGoldHistoryGraph(period, sampling, startTimeframe);
            if (rs && rs.status == 200) {
                let data = rs.data.data
                if (data) {
                    if (data) return data
                    return []
                }
            }
        } catch (error) {
            throw new Error(error)
        }
    },
    async updateGoldSpotRealtimeGraph({ commit }, payload) {
        try {
            commit(constant.GOLD_SPOT_REAL_TIME_GRAPH, payload)
        } catch (error) {
            throw new Error(error)
        }
    },
    async updateGoldSpotAggregateGraph({ commit }, payload) {
        try {
            commit(constant.GOLD_SPOT_AGGREGATE_GRAPH, payload)
        } catch (error) {
            throw new Error(error)
        }
    },
    async findGoldSpotHistoryGraph({ commit }, payload) {
        try {
            const rs = await apiGoldSpotHistoryGraph(payload);
            if (rs && rs.status == 200) {
                let data = rs.data.results
                if (data) {
                    await commit(constant.GOLD_SPOT_HISTORY_GRAPH, data)
                }
            }
        } catch (error) {
            throw new Error(error)
        }
    },
    clearGoldSpotRealtimeGraph({ state }) {
        state.goldSpotRealtimeGraph = []
        return true
    },
    clearGoldTraderRealtimeGraph({ state }) {
        state.goldTraderRealtimeGraph = []
        return true
    },
    async findGoldSpotPreviousClose({ commit }, payload) {
        const rs = await apiGoldSpotPreviousClose(payload);
        if (rs && rs.status == 200) {
            let data = rs.data.results[0]
            if (data) {
                await commit(constant.GOLD_SPOT_PREVIOUS_CLOSE, data)
            }
        }
    },
    async fetchGlobalConfiguration({ commit }, objectPath) {
        const rs = await apiFetchGcsObject(objectPath);
        if (rs && rs.status == 200) {
            let data = rs.data
            await commit(constant.GOLD_SPOT_GLOBAL_GRAPH_SETTING, data)
        }
    },
    // gold spot thai
    clearGoldSpotThaiRealtimeGraph({ state }) {
        state.goldSpotThaiRealtimeGraph = []
        return true
    },
    async updateGoldSpotThaiRealtimeGraph({ commit }, payload) {
        await commit(constant.GOLD_SPOT_THAI_REAL_TIME_GRAPH, payload)
    },
    async updateGoldTraderRealtimeGraph({ commit }, payload) {
        await commit(constant.GOLD_TRADER_REAL_TIME_GRAPH, payload)
    },
    async updateGoldSpotThaiAggregateGraph({ commit }, payload) {
        await commit(constant.GOLD_SPOT_THAI_AGGREGATE_GRAPH, payload)
    },
    updateGoldSpotThaiRealtimeCurrentPeriod({ commit }, period) {
        commit(constant.GOLD_SPOT_THAI_REALTIME_CURRENT_PERIOD, period)
    },
}